export const NON_PROXY_ENDPOINTS = [
    'v1/oauth2',
    'v1/admins',
    'v1/roles',
    'v1/permissions',
    'v1/tickets'
];